export default class customField {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/customize/modal/custom-field.html'),
            scope: {
                group: '=',
                field: '=',
                customIdentifier: '='
            },
            controller: CustomFieldCtrl,
            controllerAs: 'customField'
        }
    }
};

class CustomFieldCtrl {
    constructor($scope, $filter, $stateParams, Events, SweetAlert, Customization) {
        this._translator = $filter('translate');
        this._stateParams = $stateParams;
        this._scope = $scope;

        this.customRepo = Customization;
        this.eventHandler = Events;
        this.alerter = SweetAlert;

        this.originalName = this._scope.field.name;
        this.typesId = {
            text: 1,
            multiple: 2,
            datetime: 3,
            date: 4,
        };

        this.types = {
            1: this._translator('CUSTOMIZE:TYPE:TEXT'),
            2: this._translator('CUSTOMIZE:TYPE:MULTIPLE'),
            3: this._translator('CUSTOMIZE:TYPE:DATE_TIME'),
            4: this._translator('CUSTOMIZE:TYPE:DATE')
        };

        this.type = this.typesId[this._scope.field.type];
    }

    updateFieldType() {
        this._scope.field.type = Object.keys(this.typesId).find(key => this.typesId[key] === this.type);
        this.customRepo.updateField(this._scope.group, this._scope.field).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('CUSTOMIZE:FLASH:FIELD_UPDATED'));
        });
    };

    updateFieldName(data) {
        if (data.length < 1) {
            this._scope.field.name = '-';
            return;
        }

        this.customRepo.updateField(this._scope.group, this._scope.field).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('CUSTOMIZE:FLASH:FIELD_UPDATED'));
            this.originalName = this._scope.field.name;
        }, (error) => {
            if (error.data.code == 8) {
                this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('CUSTOMIZE:FLASH:RESERVED_KEYWORD').replace(/:name/, this._scope.field.name),
                    'type': 'error'
                });
            } else if (error.data.code == 9) {
                this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('CUSTOMIZE:FLASH:DUPLICATE_FIELD_UPDATE').replace(/:name/, this._scope.field.name),
                    type: 'error'
                });
            } else if (error.data.code == 10) {
                this.alerter.swal({
                    title: this._translator('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._translator('translate')('CUSTOMIZE:FLASH:FIELD_NAME_INVALID_OR_EMPTY'),
                    type: 'error'
                });
            } else {
                this.alerter.swal({
                    title: this._translator('GLOBAL:FLASH:OOPS'),
                    text: this._translator('CUSTOMIZE:FLASH:UPDATE_FIELD_ERROR'),
                    type: 'error'
                });
            }
            this._scope.field.name = this.originalName;
        });
    };

    removeField() {
        this.customRepo.fieldFilters(this._scope.group.id, this._scope.field.id).then((res) => {
            let filters = res.data;
            this.alerter.swal({
                title: this._translator('GLOBAL:FLASH:DELETE'),
                text: !filters.length ? this._translator('CUSTOMIZE:FLASH:DELETE_FIELD_EXPLAINED') :
                    this._translator('CUSTOMIZE:FLASH:DELETE_CAPTURED_FIELD').replace(/:filters/, filters.map((filter) => filter.name).join('\n')),
                type: 'warning',
                customClass: !filters.length ? '' : 'sweet-alert--delete',
                showCancelButton: true,
                confirmButtonText: this._translator('GLOBAL:YES'),
                cancelButtonText: this._translator('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.customRepo.removeField(this._stateParams.id, this._scope.field.id).then(() => {
                        this.eventHandler.flashEvent('notification', this._translator('CUSTOMIZE:FLASH:FIELD_DELETED'));

                        angular.forEach(this._scope.group.fields, (field, index) => {
                            if (field.id == this._scope.field.id) {
                                this._scope.group.fields.splice(index, 1);
                            }
                        });
                    }, (error) => {
                        if (error.data.code == 400) {
                            this.eventHandler.flashEvent('error', this._translator('CUSTOMIZE:FLASH:CUSTOM_IDENTIFIER_ERROR'));
                        }
                    });
                }
            })
        }).catch((error) => {
            if (error.data.code == 400) {
                this.eventHandler.flashEvent('error', this._translator('CUSTOMIZE:FLASH:CUSTOM_IDENTIFIER_ERROR'));
            }
        });
    }
}